<div backdrop></div>
<div content>
  <scrollbar class="left"></scrollbar>

  <userblock></userblock>
  <ul>
    <ng-container *ngFor='let item of layout.menu'>
      <li *ngIf="displayable(item)" [routerLinkActive]="['active']">

        <span *ngIf="item.heading">{{item.text | lang}}</span>

        <a *ngIf="!item.heading && item.text" [routerLink]="item.link" title="{{item.text | lang}}" (click)="layout.sidebar = false">
          <em class="{{item.icon}}" *ngIf="item.icon"></em>
          <span>{{item.text | lang}}</span>
        </a>
      </li>
    </ng-container>
  </ul>

</div>
